export const translations = {
  en: {
    'nav.home': 'Home',
    'nav.realEstate': 'Real Estate',
    'nav.real-estate': 'Real Estate',
    'nav.cars': 'Cars',
    'nav.finance': 'Finance',
    'language.en': 'English',
    'language.es': 'Español',
    'layout.madeWithLove': 'Made to improve productivity.',
    'home.hero.title': 'Tool Portal',
    'home.hero.subtitle': 'Your complete collection of financial calculators, analyzers, and productivity tools. Make smarter decisions with real-time calculations and data-driven insights.',
    'home.hero.cta': 'Get Started',
    'home.features.title': 'Why Choose {{project}}?',
    'home.features.subtitle': 'Built for professionals who need reliable, fast, and accurate calculations',
    'home.features.fast.title': 'Lightning Fast',
    'home.features.fast.desc': 'Real-time calculations with instant results. No waiting, no delays.',
    'home.features.privacy.title': 'Data Privacy',
    'home.features.privacy.desc': 'All calculations are done locally. Your data never leaves your device.',
    'home.features.mobile.title': 'Mobile Ready',
    'home.features.mobile.desc': 'Responsive design that works perfectly on all your devices.',
    'home.categories.title': 'Tool Categories',
    'home.categories.subtitle': 'Organized by industry and use case for easy access',
    'home.categories.toolsAvailable': '{{count}} tools available',
    'home.cta.title': 'Ready to Get Started?',
    'home.cta.subtitle': 'Join thousands of professionals who rely on {{project}} for their daily calculations and analysis needs.',
    'home.cta.button': 'Start Using Tools Now',
    'category.notFound.title': 'Category Not Found',
    'category.notFound.message': 'The category "{{category}}" doesn\'t exist.',
    'category.backHome': 'Back to Home',
    'category.header.tools': '{{name}} Tools',
    'category.header.count': 'Click on any tool below to start using it.',
    'category.comingSoon.title': 'More Tools Coming Soon',
    'category.comingSoon.message': "We're constantly adding new tools to help you make better financial decisions. Check back soon for updates!",
    'tool.notFound.title': 'Tool Not Found',
    'tool.notFound.message': 'The tool "{{tool}}" in category "{{category}}" doesn\'t exist.',
    'tool.backHome': 'Back to Home',
    'tool.underDevelopment.title': 'Tool Under Development',
    'tool.underDevelopment.message': 'This tool is currently being built. Check back soon!',
    'tool.backCategory': 'Back to {{category}}',
    'tool.breadcrumb.home': 'Home',
    'tool.result.heading': 'Result',
    'tool.result.frequency': 'Frequency',
    'tool.result.unadjusted': 'Unadjusted',
    'tool.result.adjusted': 'Holidays & vacation adjusted',
    'tool.result.adjustedShort': 'Adjusted (holidays + vacation)',
    'tool.common.calculate': 'Calculate',
    'tool.common.clear': 'Clear',
    'tool.common.assumptions': 'Assumptions',
    'tool.common.useTool': 'Use Tool',
    'notFound.title': 'Page Not Found',
    'notFound.message': 'The page you are looking for does not exist.',
    'notFound.button': 'Back to Home',
    'notFound.goBack': 'Go Back',
    'notFound.help': 'Need help? Contact support or check our documentation.',
    'dealFinder.comingSoon.title': 'Real Estate Deal Finder',
    'dealFinder.comingSoon.description': "We're building direct integrations with Zillow, Realtor.com, Redfin, and MLS feeds so you can source investment opportunities without leaving Toollyzer.",
    'dealFinder.comingSoon.tag': 'Coming soon',
    'dealFinder.comingSoon.note': 'If you already have API credentials for these platforms, hang tight—support is on the roadmap. In the meantime you can plan your sourcing strategy and gather credentials using the instructions in the documentation.',
    'financeAnalyzer.title': 'Finance Analyzer',
    'financeAnalyzer.description': 'Run detailed numbers for a vehicle purchase, estimate loan payments, upfront cash needs, and future equity.',
    'financeAnalyzer.section.vehicle': 'Vehicle Pricing',
    'financeAnalyzer.section.financing': 'Financing Terms',
    'financeAnalyzer.section.adjustments': 'Adjustments & Credits',
    'financeAnalyzer.section.equity': 'Equity Outlook',
    'financeAnalyzer.input.make': 'Make',
    'financeAnalyzer.input.msrp': 'MSRP',
    'financeAnalyzer.input.vehiclePrice': 'Vehicle Price',
    'financeAnalyzer.input.options': 'Options / Add-ons',
    'financeAnalyzer.input.loanTermMonths': 'Loan Term (months)',
    'financeAnalyzer.input.apr': 'APR (%)',
    'financeAnalyzer.input.salesTaxRate': 'Sales Tax Rate (%)',
    'financeAnalyzer.input.cashDown': 'Cash Down Payment',
    'financeAnalyzer.input.tradeInValue': 'Trade-In Value',
    'financeAnalyzer.input.tradeInPayoff': 'Trade-In Loan Payoff',
    'financeAnalyzer.input.rebates': 'Manufacturer Incentives',
    'financeAnalyzer.input.dealerFees': 'Dealer / Doc Fees',
    'financeAnalyzer.input.registrationFees': 'Registration & Title',
    'financeAnalyzer.input.warranty': 'Warranty / Protection',
    'financeAnalyzer.input.otherUpfront': 'Other Up-Front Costs',
    'financeAnalyzer.input.holdMonths': 'Hold Period (months)',
    'financeAnalyzer.input.resaleValue': 'Estimated Resale Value',
    'financeAnalyzer.summary.title': 'Finance Summary',
    'financeAnalyzer.summary.monthlyPayment': 'Monthly Payment',
    'financeAnalyzer.summary.loanAmount': 'Loan Amount',
    'financeAnalyzer.summary.dueAtSigning': 'Due at Signing',
    'financeAnalyzer.summary.firstPayment': 'First Payment',
    'financeAnalyzer.summary.cashDown': 'Cash Down',
    'financeAnalyzer.summary.otherUpfront': 'Other Up-Front',
    'financeAnalyzer.summary.salesTax': 'Sales Tax Collected',
    'financeAnalyzer.summary.totalInterest': 'Total Interest',
    'financeAnalyzer.summary.totalOutlay': 'Total Cash Outlay',
    'financeAnalyzer.summary.equityForecast': 'Equity Forecast (month {{month}})',
    'financeAnalyzer.summary.remainingBalance': 'Remaining Balance',
    'financeAnalyzer.summary.projectedEquity': 'Projected Equity',
    'financeAnalyzer.summary.note': 'Positive values favor buying.',
    'financeAnalyzer.deal.average': 'Typical Financing',
    'financeAnalyzer.deal.great': 'Great Financing',
    'financeAnalyzer.deal.bad': 'High-Cost Financing',
    'financeAnalyzer.deal.msg.average': 'This financing offer is typical for the market.',
    'financeAnalyzer.deal.msg.great': 'Low APR and light interest costs — excellent financing terms.',
    'financeAnalyzer.deal.msg.bad': 'Interest charges are high for this APR — consider negotiating or shopping around.',
    'lease.title': 'Lease & Finance Analyzer',
    'lease.description': 'Analyze your car lease or finance deal, compare costs, and see the impact of MSDs and incentives.',
    'lease.section.vehicle': 'Vehicle Information',
    'lease.section.terms': 'Lease Terms',
    'lease.section.financial': 'Financial Details',
    'lease.section.due': 'Due at Signing Details',
    'lease.section.msd': 'Multiple Security Deposits (MSD)',
    'lease.section.msd.enable': 'Enable Multiple Security Deposits',
    'lease.section.msd.deposits': 'Number of Deposits (1-9)',
    'lease.input.make': 'Make',
    'lease.input.msrp': 'MSRP (Sticker Price) *',
    'lease.helper.msrp': "Manufacturer's suggested retail price",
    'lease.input.sellingPrice': 'Negotiated Price *',
    'lease.helper.sellingPrice': 'Your negotiated selling price',
    'lease.input.term': 'Lease Term (months) *',
    'lease.input.miles': 'Annual Miles Allowed *',
    'lease.input.milesSuffix': 'miles',
    'lease.input.residualPercent': 'Residual Value (%)',
    'lease.helper.residualPercent': 'Residual as percent of MSRP',
    'lease.input.residualValue': 'Residual Value ($)',
    'lease.helper.residualValue': 'Vehicle value at lease end',
    'lease.input.moneyFactor': 'Money Factor *',
    'lease.helper.moneyFactor': 'Interest rate divided by 2400',
    'lease.input.salesTaxRate': 'Sales Tax Rate (%)',
    'lease.helper.salesTaxRate': 'Your local sales tax rate',
    'lease.input.downPayment': 'Down Payment',
    'lease.helper.downPayment': 'Enter a positive number for cap cost reduction or negative for rebates',
    'lease.input.tradeIn': 'Trade-In Value',
    'lease.helper.tradeIn': 'Your trade-in value (if any)',
    'lease.input.rebates': 'Incentives / Rebates',
    'lease.helper.rebates': 'Manufacturer or dealer incentives',
    'lease.input.acquisitionFee': 'Acquisition Fee',
    'lease.helper.acquisitionFee': 'Bank or leasing company fee',
    'lease.input.dealerFee': 'Dealer Fee',
    'lease.helper.dealerFee': 'Dealer documentation fee',
    'lease.input.govFee': 'Government Fees',
    'lease.helper.govFee': 'DMV, registration, etc.',
    'lease.input.dispositionFee': 'Disposition Fee',
    'lease.helper.dispositionFee': 'Fee at lease end (if any)',
    'lease.input.upfrontFees': 'Up-Front Fees (DMV, Reg, etc.)',
    'lease.helper.upfrontFees': 'Registration, doc, and other up-front fees',
    'lease.input.upfrontSalesTax': 'Up-Front Sales Tax',
    'lease.helper.upfrontSalesTax': 'Sales tax paid at signing (if any)',
    'lease.tab.lease': 'Lease',
    'lease.tab.finance': 'Finance',
    'lease.tab.comparison': 'Lease vs. Finance',
    'lease.summary.header.lease': 'Lease',
    'lease.summary.header.finance': 'Finance',
    'lease.summary.monthlyPayment': 'Monthly Payment:',
    'lease.summary.dueAtSigning': 'Due at Signing:',
    'lease.summary.firstPayment': 'First Payment:',
    'lease.summary.downPayment': 'Down Payment:',
    'lease.summary.upfrontFees': 'Up-Front Fees:',
    'lease.summary.upfrontSalesTax': 'Up-Front Sales Tax:',
    'lease.summary.totalCost': 'Total Cost:',
    'lease.summary.overMonths': 'over {{months}} months',
    'lease.summary.effectiveMonthly': 'Effective Monthly Cost:',
    'lease.summary.financeMonthly': 'Monthly Payment:',
    'lease.summary.financeDueAtSigning': 'Due at Signing:',
    'lease.summary.financeTotalCost': 'Total Cost:',
    'lease.summary.overFinanceMonths': 'over {{months}} months',
    'lease.summary.financeEffectiveMonthly': 'Effective Monthly Cost:',
    'lease.comparison.monthlyPayment': 'Monthly Payment:',
    'lease.comparison.dueAtSigning': 'Due at Signing:',
    'lease.comparison.totalCost': 'Total Cost:',
    'lease.comparison.effectiveMonthly': 'Effective Monthly Cost:',
    'lease.summary.share': 'Share Your Numbers',
    'lease.summary.shareHint': 'Click to generate a shareable link of your Lease vs. Finance comparison.',
    'lease.deal.great': 'Great Deal',
    'lease.deal.average': 'Average Deal',
    'lease.deal.bad': 'Bad Deal',
    'lease.deal.msg.great': 'This is a great lease deal (low APR and low effective monthly).',
    'lease.deal.msg.average': 'This lease structure looks typical for current market terms.',
    'lease.deal.msg.bad': 'This deal is worse than average (high APR or high monthly cost).',
    'lease.finance.great': 'Great Financing',
    'lease.finance.average': 'Typical Financing',
    'lease.finance.bad': 'High-Cost Financing',
    'lease.finance.msg.great': 'Low APR and a strong monthly payment compared to the price—excellent financing terms.',
    'lease.finance.msg.average': 'This financing offer tracks with standard market rates.',
    'lease.finance.msg.bad': 'APR or total interest is high for this price—consider negotiating or alternative financing.',
    'salary.title': 'Salary Calculator',
    'salary.description': 'Convert pay between hourly, daily, weekly, and annual amounts.',
    'salary.inputs.title': 'Salary Inputs',
    'salary.amount.label': 'Salary amount',
    'salary.amount.field': 'Amount',
    'salary.amount.per': 'Per',
    'salary.hoursPerWeek': 'Hours per week',
    'salary.daysPerWeek': 'Days per week',
    'salary.holidaysPerYear': 'Holidays per year',
    'salary.vacationPerYear': 'Vacation days per year',
    'salary.assumptions': 'Assumptions',
    'salary.assumption1': 'Unadjusted values assume 52 work weeks (260 weekdays).',
    'salary.assumption2': 'Adjusted values subtract the holidays and vacation days entered above.',
    'salary.assumption3': 'Change the frequency dropdown to convert from any pay cadence.',
    'salary.result.frequency': 'Frequency',
    'salary.result.unadjusted': 'Unadjusted',
    'salary.result.adjusted': 'Holidays & vacation adjusted',
    'salary.result.heading': 'Result',
    'salary.range.hourly': 'Hourly',
    'salary.range.daily': 'Daily',
    'salary.range.weekly': 'Weekly',
    'salary.range.biweekly': 'Bi-weekly',
    'salary.range.semiMonthly': 'Semi-monthly',
    'salary.range.monthly': 'Monthly',
    'salary.range.quarterly': 'Quarterly',
    'salary.range.annual': 'Annual',
    'brrr.title': 'BRRR Calculator (Buy → Rehab → Rent → Refinance → Repeat)',
    'brrr.description': 'Analyze a BRRR project, estimate NOI, market value, loan proceeds, and DSCR before refinancing.',
    'brrr.section.project': 'Project Inputs',
    'brrr.section.loan': 'Refinance & Loan',
    'brrr.section.metrics': 'Income & Metrics',
    'brrr.section.formulas': 'Key Formulas',
    'brrr.input.purchase': 'Purchase price',
    'brrr.input.rehab': 'Rehab costs',
    'brrr.input.rent': 'Monthly rent (gross)',
    'brrr.input.vacancy': 'Vacancy (%)',
    'brrr.input.expenses': 'Annual expenses',
    'brrr.input.capRate': 'Market cap rate (%)',
    'brrr.input.ltv': 'Bank LTV (%)',
    'brrr.input.payoff': 'Current payoff to refinance',
    'brrr.input.rate': 'Interest rate (%)',
    'brrr.input.term': 'Term (years)',
    'brrr.output.totalCost': 'Total investment',
    'brrr.output.value': 'Income capitalization value',
    'brrr.output.maxLoan': 'Maximum loan (LTV)',
    'brrr.output.cashout': 'Potential cash-out',
    'brrr.output.grossIncome': 'Gross annual income',
    'brrr.output.vacancy': 'Vacancy allowance',
    'brrr.output.effectiveIncome': 'Effective income',
    'brrr.output.noi': 'Net operating income (NOI)',
    'brrr.output.payment': 'Estimated monthly payment',
    'brrr.output.cashflow': 'Monthly cash flow',
    'brrr.output.dscr': 'DSCR',
    'brrr.dscr.solid': 'Strong',
    'brrr.dscr.acceptable': 'Acceptable',
    'brrr.dscr.risky': 'Risky',
    'brrr.formula.noi': 'NOI = (Rent × 12 × (1 − vacancy)) − annual expenses.',
    'brrr.formula.value': 'Value = NOI ÷ cap rate.',
    'brrr.formula.maxLoan': 'Maximum loan = Value × LTV.',
    'brrr.formula.dscr': 'DSCR = NOI ÷ (monthly payment × 12).',
    'loanAmortization.title': 'Loan Amortization Schedule Calculator',
    'loanAmortization.description': 'Enter your loan details, see each payment until payoff, and export or print the full amortization schedule.',
    'loanAmortization.section.inputs': 'Loan Inputs',
    'loanAmortization.section.schedule': 'Amortization Schedule',
    'loanAmortization.input.amount': 'Loan amount',
    'loanAmortization.input.apr': 'APR (%)',
    'loanAmortization.input.payments': 'Number of payments',
    'loanAmortization.input.extra': 'Additional payment',
    'loanAmortization.output.basePayment': 'Base monthly payment',
    'loanAmortization.output.totalInterest': 'Total interest paid',
    'loanAmortization.output.totalPaid': 'Total of all payments',
    'loanAmortization.actions.export': 'Export CSV',
    'loanAmortization.actions.print': 'Print schedule',
    'loanAmortization.table.payment': 'Payment #',
    'loanAmortization.table.basePayment': 'Base Payment',
    'loanAmortization.table.extraPayment': 'Extra Payment',
    'loanAmortization.table.principal': 'Principal',
    'loanAmortization.table.interest': 'Interest',
    'loanAmortization.table.balance': 'Remaining Balance',
    'loanAmortization.empty': 'Enter loan inputs to generate the schedule.',
    'category.description.real-estate': 'Investment analysis and property tools',
    'category.description.cars': 'Automotive financial calculators and tools',
    'category.description.finance': 'General financial planning and analysis tools',
    'tool.name.fix-flip-roi': 'Fix & Flip ROI Calculator',
    'tool.desc.fix-flip-roi': 'Calculate return on investment for fix and flip properties',
    'tool.name.buy-vs-rent': 'Buy vs Rent Calculator',
    'tool.desc.buy-vs-rent': 'Compare the costs of buying versus renting',
    'tool.name.deal-finder': 'Deal Finder',
    'tool.desc.deal-finder': 'Find profitable real estate deals from multiple sources',
    'tool.name.brrr-calculator': 'BRRR Calculator',
    'tool.desc.brrr-calculator': 'Analyze a BRRR project with NOI, cap rate value, refinancing proceeds, and DSCR',
    'tool.name.mortgage-amortization': 'Mortgage Amortization Calculator',
    'tool.desc.mortgage-amortization': 'Build detailed mortgage payoff schedules with extra payments',
    'tool.name.loan-amortization': 'Loan Amortization Schedule Calculator',
    'tool.desc.loan-amortization': 'Create amortization schedules with extra payments, export or print the payoff plan',
    'tool.name.finance-analyzer': 'Finance Analyzer',
    'tool.desc.finance-analyzer': 'Build auto loan scenarios and forecast equity',
    'tool.name.lease-analyzer': 'Lease Analyzer',
    'tool.desc.lease-analyzer': 'Analyze car lease deals and money factor calculations',
    'tool.name.depreciation-calculator': 'Depreciation Calculator',
    'tool.desc.depreciation-calculator': 'Calculate vehicle depreciation over time',
    'tool.name.compound-interest': 'Compound Interest Calculator',
    'tool.desc.compound-interest': 'Calculate compound interest and investment growth',
    'tool.name.salary-calculator': 'Salary Calculator',
    'tool.desc.salary-calculator': 'Convert pay between hourly, daily, weekly, and annual amounts',
    'buyRent.title': 'Buy vs Rent Calculator',
    'buyRent.description': 'Compare the long-term costs of buying a home versus renting. Adjust the assumptions to reflect your local market and personal plans.',
    'buyRent.section.purchase': 'Purchase Details',
    'buyRent.section.carry': 'Carrying Costs',
    'buyRent.section.rent': 'Rent & Investment',
    'buyRent.input.purchasePrice': 'Purchase Price',
    'buyRent.input.downPayment': 'Down Payment (%)',
    'buyRent.input.mortgageRate': 'Mortgage Rate (%)',
    'buyRent.input.loanTerm': 'Loan Term (years)',
    'buyRent.input.closingCosts': 'Closing Costs (%)',
    'buyRent.input.appreciation': 'Home Appreciation (%)',
    'buyRent.input.sellingCosts': 'Selling Costs (%)',
    'buyRent.input.horizon': 'Time Horizon (years)',
    'buyRent.input.propertyTax': 'Property Tax Rate (%)',
    'buyRent.input.insurance': 'Home Insurance (annual)',
    'buyRent.input.maintenance': 'Maintenance (% of value)',
    'buyRent.input.hoa': 'HOA Fees (monthly)',
    'buyRent.input.monthlyRent': 'Monthly Rent',
    'buyRent.input.rentIncrease': 'Annual Rent Increase (%)',
    'buyRent.input.rentersInsurance': "Renter's Insurance (monthly)",
    'buyRent.input.securityDeposit': 'Security Deposit',
    'buyRent.input.investmentReturn': 'Investment Return (%)',
    'buyRent.summary.title': 'Comparison Summary',
    'buyRent.summary.buyLabel': 'Buy',
    'buyRent.summary.rentLabel': 'Rent',
    'buyRent.summary.owningMonthly': 'Monthly Owning Cost',
    'buyRent.summary.taxes': 'Taxes',
    'buyRent.summary.ins': 'Ins',
    'buyRent.summary.maint': 'Maint',
    'buyRent.summary.rentMonthly': 'Starting Monthly Rent',
    'buyRent.summary.avgRent': 'Average rent during horizon',
    'buyRent.summary.totalOutlay': 'Total Cash Outlay',
    'buyRent.summary.netCost': 'Net Cost (after equity)',
    'buyRent.summary.advantage': 'Advantage',
    'buyRent.summary.note': 'Positive values favor buying.',
    'buyRent.summary.advantage.even': 'Nearly Even',
    'buyRent.summary.advantage.buy': 'Buying Advantage',
    'buyRent.summary.advantage.rent': 'Renting Advantage',
    'buyRent.summary.message.default': 'Enter property price, mortgage details, and time horizon to compare.',
    'buyRent.summary.message.even': 'Over this horizon the total costs of buying and renting are very close.',
    'buyRent.summary.message.buy': 'Owning builds more net value than renting given these assumptions.',
    'buyRent.summary.message.rent': 'Renting leaves you with more net wealth than buying in this scenario.',
    'fixFlip.instructions.title': 'How to Use This Calculator',
    'fixFlip.instructions.intro': 'Enter your property details below to calculate the potential return on investment (ROI) for a fix and flip project. The calculator will provide real-time results as you type.',
    'fixFlip.instructions.purchase': "• Purchase Price: The amount you'll pay to acquire the property",
    'fixFlip.instructions.rehab': '• Rehab Cost: Estimated renovation and repair expenses',
    'fixFlip.instructions.arv': '• ARV: After Repair Value - what the property will be worth after fixes',
    'fixFlip.instructions.selling': '• Selling Costs: Agent fees, closing costs, etc. (typically 6-8% of ARV)',
    'fixFlip.instructions.holding': '• Holding Costs: Insurance, utilities, taxes while you own it',
    'fixFlip.inputs.title': 'Property Details',
    'fixFlip.input.purchase': 'Purchase Price',
    'fixFlip.input.rehab': 'Rehab Cost',
    'fixFlip.input.arv': 'After Repair Value (ARV)',
    'fixFlip.input.selling': 'Selling Costs (6-8% of ARV)',
    'fixFlip.input.holding': 'Holding Costs',
    'fixFlip.results.title': 'ROI Analysis',
    'fixFlip.results.goodDeal': 'Good Deal',
    'fixFlip.results.review': 'Review Carefully',
    'fixFlip.results.totalInvestment': 'Total Investment',
    'fixFlip.results.netProfit': 'Net Profit',
    'fixFlip.results.roiPercentage': 'ROI Percentage',
    'fixFlip.results.analysisTitle': 'Analysis',
    'fixFlip.results.analysisLine1': '• Target ROI for fix & flip: 20%+ (yours: {{roi}}%)',
    'fixFlip.results.analysisLine2': '• Consider market conditions and timeline risks',
    'fixFlip.results.empty': 'Enter property details above to see ROI analysis',
    'depreciation.title': 'Depreciation Calculator',
    'depreciation.description': 'Estimate a vehicle\'s value as it ages, factor in mileage impact, and visualize depreciation over time.',
    'depreciation.section.profile': 'Vehicle Profile',
    'depreciation.section.assumptions': 'Depreciation Assumptions',
    'depreciation.input.make': 'Make',
    'depreciation.input.modelYear': 'Model Year',
    'depreciation.input.purchasePrice': 'Purchase Price',
    'depreciation.input.purchaseMileage': 'Miles at Purchase',
    'depreciation.input.currentMileage': 'Current Odometer',
    'depreciation.input.yearsOwned': 'Years Since Purchase',
    'depreciation.input.avgAnnualMiles': 'Average Annual Miles',
    'depreciation.input.baselineAnnualMiles': 'Baseline Annual Miles',
    'depreciation.input.yearOneDrop': 'Year 1 Drop (%)',
    'depreciation.input.ongoingDrop': 'Annual Drop After Year 1 (%)',
    'depreciation.input.mileageAdjustment': 'Mileage Adjustment per 1k Miles',
    'depreciation.input.holdYears': 'Plan to Keep (years)',
    'depreciation.summary.title': 'Depreciation Summary',
    'depreciation.summary.caption': 'Based on {{years}} years owned',
    'depreciation.summary.currentValue': 'Estimated Current Value',
    'depreciation.summary.totalDepreciation': 'Total Depreciation',
    'depreciation.summary.avgAnnual': 'Avg Annual Depreciation',
    'depreciation.summary.projected': 'Projected Value (Year {{year}})',
    'depreciation.summary.quality.great': 'Great Retention',
    'depreciation.summary.quality.typical': 'Typical Depreciation',
    'depreciation.summary.quality.rapid': 'Rapid Depreciation',
    'depreciation.summary.qualityMsg.great': 'This vehicle is holding value very well versus the purchase price.',
    'depreciation.summary.qualityMsg.typical': 'Depreciation is in line with market averages for most vehicles.',
    'depreciation.summary.qualityMsg.rapid': 'Depreciation is steep compared to the purchase price — expect faster value loss.',
    'depreciation.table.title': 'Depreciation Timeline',
    'depreciation.table.year': 'Year',
    'depreciation.table.value': 'Estimated Value',
    'depreciation.table.depreciation': 'Annual Depreciation',
    'depreciation.table.actualMiles': 'Actual Miles',
    'depreciation.table.expectedMiles': 'Expected Miles',
    'depreciation.table.mileagePenalty': 'Mileage Penalty',
    'depreciation.table.milesSuffix': 'mi',
    'depreciation.empty': 'Enter vehicle details to calculate depreciation.',
    'compound.title': 'Compound Interest Calculator',
    'compound.description': 'Model long-term investment growth with recurring contributions and adjustable yields. Review the yearly build-up of contributions versus earnings.',
    'compound.section.inputs': 'Inputs',
    'compound.section.guidance': 'Guidance',
    'compound.input.initialInvestment': 'Initial Investment',
    'compound.input.recurringContribution': 'Recurring Contribution',
    'compound.input.annualRate': 'Annual Interest Rate (%)',
    'compound.input.compoundingFrequency': 'Compounding Frequency (per year)',
    'compound.input.contributionFrequency': 'Contribution Frequency (per year)',
    'compound.input.yearsToGrow': 'Years to Grow',
    'compound.input.rateAdjustment': 'Rate Adjustment per Year (%)',
    'compound.frequency.monthly': 'Monthly',
    'compound.frequency.quarterly': 'Quarterly',
    'compound.frequency.semiAnnual': 'Semi-Annually',
    'compound.frequency.annual': 'Annually',
    'compound.guidance.adjustment': 'Use the rate adjustment to model changing returns (e.g., reduce by 0.5% each year).',
    'compound.guidance.frequency': 'Contribution frequency should match how often you invest (12 = monthly, 4 = quarterly).',
    'compound.guidance.negative': 'Negative adjustments can simulate declining returns or conservative projections.',
    'compound.summary.title': 'Results',
    'compound.summary.futureValue': 'Future Value',
    'compound.summary.totalContributions': 'Total Contributions',
    'compound.summary.growth': 'Investment Growth',
    'compound.table.title': 'Yearly Breakdown',
    'compound.table.year': 'Year',
    'compound.table.balance': 'Balance',
    'compound.table.contributions': 'Contributions',
    'compound.table.growth': 'Growth',
    'compound.table.effectiveRate': 'Effective Rate',
    'compound.empty': 'Enter investment details to calculate compound growth.'
  },
  es: {
    'nav.home': 'Inicio',
    'nav.realEstate': 'Bienes Raíces',
    'nav.real-estate': 'Bienes Raíces',
    'nav.cars': 'Autos',
    'nav.finance': 'Finanzas',
    'language.en': 'English',
    'language.es': 'Español',
    'layout.madeWithLove': 'Hecho para mejorar la productividad.',
    'home.hero.title': 'Portal de Herramientas',
    'home.hero.subtitle': 'Tu colección completa de calculadoras financieras, analizadores y herramientas de productividad. Toma decisiones más inteligentes con cálculos en tiempo real y conocimientos basados en datos.',
    'home.hero.cta': 'Comenzar',
    'home.features.title': '¿Por qué elegir {{project}}?',
    'home.features.subtitle': 'Diseñado para profesionales que necesitan cálculos confiables, rápidos y precisos',
    'home.features.fast.title': 'Velocidad Imparable',
    'home.features.fast.desc': 'Cálculos en tiempo real con resultados instantáneos. Sin esperas, sin retrasos.',
    'home.features.privacy.title': 'Privacidad de Datos',
    'home.features.privacy.desc': 'Todos los cálculos se realizan localmente. Tus datos nunca salen de tu dispositivo.',
    'home.features.mobile.title': 'Listo para Móviles',
    'home.features.mobile.desc': 'Diseño adaptable que funciona perfectamente en todos tus dispositivos.',
    'home.categories.title': 'Categorías de Herramientas',
    'home.categories.subtitle': 'Organizadas por industria y caso de uso para un acceso sencillo',
    'home.categories.toolsAvailable': '{{count}} herramientas disponibles',
    'home.cta.title': '¿Listo para empezar?',
    'home.cta.subtitle': 'Únete a miles de profesionales que confían en {{project}} para sus cálculos y análisis diarios.',
    'home.cta.button': 'Usar herramientas ahora',
    'category.notFound.title': 'Categoría no encontrada',
    'category.notFound.message': 'La categoría "{{category}}" no existe.',
    'category.backHome': 'Volver al inicio',
    'category.header.tools': 'Herramientas de {{name}}',
    'category.header.count': 'Haz clic en cualquier herramienta para comenzar a usarla.',
    'category.comingSoon.title': 'Más herramientas próximamente',
    'category.comingSoon.message': 'Estamos agregando constantemente nuevas herramientas para ayudarte a tomar mejores decisiones financieras. ¡Vuelve pronto para ver las novedades!',
    'tool.notFound.title': 'Herramienta no encontrada',
    'tool.notFound.message': 'La herramienta "{{tool}}" en la categoría "{{category}}" no existe.',
    'tool.backHome': 'Volver al inicio',
    'tool.underDevelopment.title': 'Herramienta en desarrollo',
    'tool.underDevelopment.message': 'Esta herramienta se está construyendo. ¡Vuelve pronto!',
    'tool.backCategory': 'Volver a {{category}}',
    'tool.breadcrumb.home': 'Inicio',
    'tool.result.heading': 'Resultado',
    'tool.result.frequency': 'Frecuencia',
    'tool.result.unadjusted': 'Sin ajuste',
    'tool.result.adjusted': 'Ajustado por vacaciones y feriados',
    'tool.result.adjustedShort': 'Ajustado (feriados + vacaciones)',
    'tool.common.calculate': 'Calcular',
    'tool.common.clear': 'Limpiar',
    'tool.common.assumptions': 'Suposiciones',
    'tool.common.useTool': 'Usar herramienta',
    'notFound.title': 'Página no encontrada',
    'notFound.message': 'La página que buscas no existe.',
    'notFound.button': 'Volver al inicio',
    'notFound.goBack': 'Volver',
    'notFound.help': '¿Necesitas ayuda? Contacta soporte o consulta nuestra documentación.',
    'dealFinder.comingSoon.title': 'Buscador de Ofertas Inmobiliarias',
    'dealFinder.comingSoon.description': 'Estamos creando integraciones directas con Zillow, Realtor.com, Redfin y MLS para que puedas encontrar oportunidades de inversión sin salir de Toollyzer.',
    'dealFinder.comingSoon.tag': 'Próximamente',
    'dealFinder.comingSoon.note': 'Si ya tienes credenciales de estas plataformas, permanece atento: el soporte está en la hoja de ruta. Mientras tanto, puedes planificar tu estrategia y reunir las credenciales siguiendo las instrucciones de la documentación.',
    'financeAnalyzer.title': 'Analizador de Financiamiento',
    'financeAnalyzer.description': 'Calcula números detallados para una compra de vehículo, estima pagos, efectivo inicial y plusvalía futura.',
    'financeAnalyzer.section.vehicle': 'Información del vehículo',
    'financeAnalyzer.section.financing': 'Condiciones de financiamiento',
    'financeAnalyzer.section.adjustments': 'Ajustes y créditos',
    'financeAnalyzer.section.equity': 'Perspectiva de plusvalía',
    'financeAnalyzer.input.make': 'Marca',
    'financeAnalyzer.input.msrp': 'MSRP',
    'financeAnalyzer.input.vehiclePrice': 'Precio del vehículo',
    'financeAnalyzer.input.options': 'Opciones / Extras',
    'financeAnalyzer.input.loanTermMonths': 'Plazo del préstamo (meses)',
    'financeAnalyzer.input.apr': 'APR (%)',
    'financeAnalyzer.input.salesTaxRate': 'Tasa de impuesto (%)',
    'financeAnalyzer.input.cashDown': 'Pago inicial',
    'financeAnalyzer.input.tradeInValue': 'Valor del trade-in',
    'financeAnalyzer.input.tradeInPayoff': 'Pago del préstamo del trade-in',
    'financeAnalyzer.input.rebates': 'Incentivos del fabricante',
    'financeAnalyzer.input.dealerFees': 'Gastos del concesionario',
    'financeAnalyzer.input.registrationFees': 'Registro y título',
    'financeAnalyzer.input.warranty': 'Garantía / Protección',
    'financeAnalyzer.input.otherUpfront': 'Otros costos iniciales',
    'financeAnalyzer.input.holdMonths': 'Período de retención (meses)',
    'financeAnalyzer.input.resaleValue': 'Valor de reventa estimado',
    'financeAnalyzer.summary.title': 'Resumen de financiamiento',
    'financeAnalyzer.summary.monthlyPayment': 'Pago mensual',
    'financeAnalyzer.summary.loanAmount': 'Monto del préstamo',
    'financeAnalyzer.summary.dueAtSigning': 'A pagar al firmar',
    'financeAnalyzer.summary.firstPayment': 'Primer pago',
    'financeAnalyzer.summary.cashDown': 'Pago inicial',
    'financeAnalyzer.summary.otherUpfront': 'Otros costos',
    'financeAnalyzer.summary.salesTax': 'Impuesto recaudado',
    'financeAnalyzer.summary.totalInterest': 'Interés total',
    'financeAnalyzer.summary.totalOutlay': 'Desembolso total',
    'financeAnalyzer.summary.equityForecast': 'Proyección de plusvalía (mes {{month}})',
    'financeAnalyzer.summary.remainingBalance': 'Saldo restante',
    'financeAnalyzer.summary.projectedEquity': 'Plusvalía proyectada',
    'financeAnalyzer.deal.average': 'Financiamiento típico',
    'financeAnalyzer.deal.great': 'Financiamiento excelente',
    'financeAnalyzer.deal.bad': 'Financiamiento costoso',
    'financeAnalyzer.deal.msg.average': 'Esta oferta de financiamiento es habitual en el mercado.',
    'financeAnalyzer.deal.msg.great': 'APR bajo y costos de interés reducidos: condiciones excelentes.',
    'financeAnalyzer.deal.msg.bad': 'Los intereses son altos para esta APR; considera negociar o buscar alternativas.',
    'lease.title': 'Analizador de leasing y financiamiento',
    'lease.description': 'Analiza un arrendamiento o financiamiento de vehículo, compara costos y evalúa el impacto de MSD e incentivos.',
    'lease.section.vehicle': 'Información del vehículo',
    'lease.section.terms': 'Condiciones del arrendamiento',
    'lease.section.financial': 'Detalles financieros',
    'lease.section.due': 'Detalles al firmar',
    'lease.section.msd': 'Depósitos de seguridad múltiples (MSD)',
    'lease.section.msd.enable': 'Activar depósitos de seguridad múltiples',
    'lease.section.msd.deposits': 'Cantidad de depósitos (1-9)',
    'lease.input.make': 'Marca',
    'lease.input.msrp': 'MSRP (precio de lista) *',
    'lease.helper.msrp': 'Precio sugerido por el fabricante',
    'lease.input.sellingPrice': 'Precio negociado *',
    'lease.helper.sellingPrice': 'Tu precio negociado de venta',
    'lease.input.term': 'Plazo del arrendamiento (meses) *',
    'lease.input.miles': 'Kilometraje anual permitido *',
    'lease.input.milesSuffix': 'millas',
    'lease.input.residualPercent': 'Valor residual (%)',
    'lease.helper.residualPercent': 'Residual como porcentaje del MSRP',
    'lease.input.residualValue': 'Valor residual ($)',
    'lease.helper.residualValue': 'Valor del vehículo al terminar el arrendamiento',
    'lease.input.moneyFactor': 'Money factor *',
    'lease.helper.moneyFactor': 'Tasa de interés dividida entre 2400',
    'lease.input.salesTaxRate': 'Tasa de impuesto (%)',
    'lease.helper.salesTaxRate': 'Tu tasa de impuesto local',
    'lease.input.downPayment': 'Pago inicial',
    'lease.helper.downPayment': 'Ingresa un número positivo para reducir el capital o negativo para reembolsos',
    'lease.input.tradeIn': 'Valor de intercambio',
    'lease.helper.tradeIn': 'Valor de tu trade-in (si aplica)',
    'lease.input.rebates': 'Incentivos / Reembolsos',
    'lease.helper.rebates': 'Incentivos del fabricante o concesionario',
    'lease.input.acquisitionFee': 'Cargo de adquisición',
    'lease.helper.acquisitionFee': 'Cargo del banco o compañía de leasing',
    'lease.input.dealerFee': 'Cargo del concesionario',
    'lease.helper.dealerFee': 'Cargo de documentación del concesionario',
    'lease.input.govFee': 'Gastos gubernamentales',
    'lease.helper.govFee': 'DMV, registro, etc.',
    'lease.input.dispositionFee': 'Cargo de disposición',
    'lease.helper.dispositionFee': 'Cargo al finalizar el lease (si aplica)',
    'lease.input.upfrontFees': 'Gastos iniciales (DMV, registro, etc.)',
    'lease.helper.upfrontFees': 'Registro, documentación y otros gastos iniciales',
    'lease.input.upfrontSalesTax': 'Impuesto pagado al firmar',
    'lease.helper.upfrontSalesTax': 'Impuesto a la venta pagado al firmar (si aplica)',
    'lease.tab.lease': 'Arrendamiento',
    'lease.tab.finance': 'Financiar',
    'lease.tab.comparison': 'Arrendamiento vs. Financiamiento',
    'lease.summary.header.lease': 'Arrendamiento',
    'lease.summary.header.finance': 'Financiamiento',
    'lease.summary.monthlyPayment': 'Pago mensual:',
    'lease.summary.dueAtSigning': 'A pagar al firmar:',
    'lease.summary.firstPayment': 'Primer pago:',
    'lease.summary.downPayment': 'Pago inicial:',
    'lease.summary.upfrontFees': 'Gastos iniciales:',
    'lease.summary.upfrontSalesTax': 'Impuesto inicial:',
    'lease.summary.totalCost': 'Costo total:',
    'lease.summary.overMonths': 'en {{months}} meses',
    'lease.summary.effectiveMonthly': 'Costo mensual efectivo:',
    'lease.summary.financeMonthly': 'Pago mensual:',
    'lease.summary.financeDueAtSigning': 'A pagar al firmar:',
    'lease.summary.financeTotalCost': 'Costo total:',
    'lease.summary.overFinanceMonths': 'en {{months}} meses',
    'lease.summary.financeEffectiveMonthly': 'Costo mensual efectivo:',
    'lease.comparison.monthlyPayment': 'Pago mensual:',
    'lease.comparison.dueAtSigning': 'A pagar al firmar:',
    'lease.comparison.totalCost': 'Costo total:',
    'lease.comparison.effectiveMonthly': 'Costo mensual efectivo:',
    'lease.summary.share': 'Comparte tus números',
    'lease.summary.shareHint': 'Genera un enlace compartible con tu comparación de arrendamiento vs. financiamiento.',
    'lease.deal.great': 'Gran oferta',
    'lease.deal.average': 'Oferta promedio',
    'lease.deal.bad': 'Oferta desfavorable',
    'lease.deal.msg.great': 'Arrendamiento muy competitivo (money factor y pago efectivos bajos).',
    'lease.deal.msg.average': 'Esta estructura de arrendamiento es típica del mercado.',
    'lease.deal.msg.bad': 'El arrendamiento es menos favorable (APR alto o costo mensual elevado).',
    'lease.finance.great': 'Financiamiento excelente',
    'lease.finance.average': 'Financiamiento típico',
    'lease.finance.bad': 'Financiamiento costoso',
    'lease.finance.msg.great': 'APR bajo y pago competitivo; condiciones excelentes.',
    'lease.finance.msg.average': 'Esta oferta de financiamiento sigue las tasas estándar del mercado.',
    'lease.finance.msg.bad': 'El APR o el interés total es alto; considera negociar o buscar alternativas.',
    'salary.title': 'Calculadora de salario',
    'salary.description': 'Convierte tu pago entre montos por hora, día, semana y año.',
    'salary.inputs.title': 'Entradas de salario',
    'salary.amount.label': 'Monto del salario',
    'salary.amount.field': 'Monto',
    'salary.amount.per': 'Por',
    'salary.hoursPerWeek': 'Horas por semana',
    'salary.daysPerWeek': 'Días por semana',
    'salary.holidaysPerYear': 'Feriados por año',
    'salary.vacationPerYear': 'Días de vacaciones por año',
    'salary.assumptions': 'Suposiciones',
    'salary.assumption1': 'Los valores sin ajustar asumen 52 semanas laborales (260 días hábiles).',
    'salary.assumption2': 'Los valores ajustados restan los feriados y días de vacaciones ingresados.',
    'salary.assumption3': 'Cambia la frecuencia para convertir desde cualquier tipo de pago.',
    'salary.result.frequency': 'Frecuencia',
    'salary.result.unadjusted': 'Sin ajustar',
    'salary.result.adjusted': 'Ajustado por vacaciones y feriados',
    'salary.result.heading': 'Resultado',
    'salary.range.hourly': 'Por hora',
    'salary.range.daily': 'Diario',
    'salary.range.weekly': 'Semanal',
    'salary.range.biweekly': 'Quincenal',
    'salary.range.semiMonthly': 'Semimensual',
    'salary.range.monthly': 'Mensual',
    'salary.range.quarterly': 'Trimestral',
    'salary.range.annual': 'Anual',
    'brrr.title': 'Calculadora BRRR (Compra → Rehabilita → Renta → Refinancia → Repite)',
    'brrr.description': 'Analiza un proyecto BRRR, estima NOI, valor de mercado, fondos del préstamo y DSCR antes de refinanciar.',
    'brrr.section.project': 'Entradas del proyecto',
    'brrr.section.loan': 'Refinanciamiento y préstamo',
    'brrr.section.metrics': 'Ingresos y métricas',
    'brrr.section.formulas': 'Fórmulas clave',
    'brrr.input.purchase': 'Precio de compra',
    'brrr.input.rehab': 'Costos de rehabilitación',
    'brrr.input.rent': 'Renta mensual (bruta)',
    'brrr.input.vacancy': 'Vacancia (%)',
    'brrr.input.expenses': 'Gastos anuales',
    'brrr.input.capRate': 'Cap rate de mercado (%)',
    'brrr.input.ltv': 'LTV del banco (%)',
    'brrr.input.payoff': 'Saldo actual a refinanciar',
    'brrr.input.rate': 'Tasa de interés (%)',
    'brrr.input.term': 'Plazo (años)',
    'brrr.output.totalCost': 'Inversión total',
    'brrr.output.value': 'Valor por capitalización',
    'brrr.output.maxLoan': 'Préstamo máximo (LTV)',
    'brrr.output.cashout': 'Posible cash-out',
    'brrr.output.grossIncome': 'Ingreso bruto anual',
    'brrr.output.vacancy': 'Vacancia estimada',
    'brrr.output.effectiveIncome': 'Ingreso efectivo',
    'brrr.output.noi': 'NOI',
    'brrr.output.payment': 'Pago mensual estimado',
    'brrr.output.cashflow': 'Flujo mensual',
    'brrr.output.dscr': 'DSCR',
    'brrr.dscr.solid': 'Sólido',
    'brrr.dscr.acceptable': 'Aceptable',
    'brrr.dscr.risky': 'Riesgoso',
    'brrr.formula.noi': 'NOI = (Renta × 12 × (1 − vacancia)) − gastos anuales.',
    'brrr.formula.value': 'Valor = NOI ÷ cap rate.',
    'brrr.formula.maxLoan': 'Préstamo máximo = Valor × LTV.',
    'brrr.formula.dscr': 'DSCR = NOI ÷ (pago mensual × 12).',
    'loanAmortization.title': 'Calculadora de amortización de préstamo',
    'loanAmortization.description': 'Ingresa los datos del préstamo, visualiza cada pago hasta la liquidación y exporta o imprime el cronograma.',
    'loanAmortization.section.inputs': 'Entradas del préstamo',
    'loanAmortization.section.schedule': 'Cronograma de amortización',
    'loanAmortization.input.amount': 'Monto del préstamo',
    'loanAmortization.input.apr': 'APR (%)',
    'loanAmortization.input.payments': 'Número de pagos',
    'loanAmortization.input.extra': 'Pago adicional',
    'loanAmortization.output.basePayment': 'Pago mensual base',
    'loanAmortization.output.totalInterest': 'Interés total pagado',
    'loanAmortization.output.totalPaid': 'Total pagado',
    'loanAmortization.actions.export': 'Exportar CSV',
    'loanAmortization.actions.print': 'Imprimir cronograma',
    'loanAmortization.table.payment': 'Pago #',
    'loanAmortization.table.basePayment': 'Pago base',
    'loanAmortization.table.extraPayment': 'Pago adicional',
    'loanAmortization.table.principal': 'Capital',
    'loanAmortization.table.interest': 'Interés',
    'loanAmortization.table.balance': 'Saldo restante',
    'loanAmortization.empty': 'Ingresa los datos del préstamo para generar el cronograma.',
    'category.description.real-estate': 'Herramientas de análisis e inversión inmobiliaria',
    'category.description.cars': 'Calculadoras financieras relacionadas con automóviles',
    'category.description.finance': 'Herramientas de planificación y análisis financiero general',
    'tool.name.fix-flip-roi': 'Calculadora ROI de Fix & Flip',
    'tool.desc.fix-flip-roi': 'Calcula el retorno de inversión en proyectos de compra, renovación y venta',
    'tool.name.buy-vs-rent': 'Calculadora Comprar vs Rentar',
    'tool.desc.buy-vs-rent': 'Compara los costos de comprar frente a alquilar una vivienda',
    'tool.name.deal-finder': 'Buscador de Ofertas',
    'tool.desc.deal-finder': 'Encuentra propiedades rentables desde múltiples fuentes',
    'tool.name.brrr-calculator': 'Calculadora BRRR',
    'tool.desc.brrr-calculator': 'Analiza un proyecto BRRR con NOI, valor por cap rate, préstamos y DSCR',
    'tool.name.mortgage-amortization': 'Calculadora de amortización hipotecaria',
    'tool.desc.mortgage-amortization': 'Construye cronogramas detallados de pago hipotecario con pagos adicionales',
    'tool.name.loan-amortization': 'Calculadora de amortización de préstamo',
    'tool.desc.loan-amortization': 'Genera cronogramas de amortización con pagos extra, listo para exportar o imprimir',
    'tool.name.finance-analyzer': 'Analizador de Financiamiento',
    'tool.desc.finance-analyzer': 'Construye escenarios de préstamo automotriz y proyecta la plusvalía',
    'tool.name.lease-analyzer': 'Analizador de Arrendamientos',
    'tool.desc.lease-analyzer': 'Analiza contratos de arrendamiento y factores de interés',
    'tool.name.depreciation-calculator': 'Calculadora de Depreciación',
    'tool.desc.depreciation-calculator': 'Calcula la depreciación del vehículo con el tiempo',
    'tool.name.compound-interest': 'Calculadora de Interés Compuesto',
    'tool.desc.compound-interest': 'Calcula el crecimiento de inversiones con interés compuesto',
    'tool.name.salary-calculator': 'Calculadora de Salario',
    'tool.desc.salary-calculator': 'Convierte el pago entre montos por hora, día, semana y año',
    'buyRent.title': 'Calculadora Comprar vs Rentar',
    'buyRent.description': 'Compara los costos a largo plazo de comprar una vivienda frente a alquilar. Ajusta los supuestos según tu mercado local y planes personales.',
    'buyRent.section.purchase': 'Detalles de compra',
    'buyRent.section.carry': 'Costos de mantenimiento',
    'buyRent.section.rent': 'Renta e inversión',
    'buyRent.input.purchasePrice': 'Precio de compra',
    'buyRent.input.downPayment': 'Enganche (%)',
    'buyRent.input.mortgageRate': 'Tasa hipotecaria (%)',
    'buyRent.input.loanTerm': 'Plazo del préstamo (años)',
    'buyRent.input.closingCosts': 'Costos de cierre (%)',
    'buyRent.input.appreciation': 'Apreciación anual (%)',
    'buyRent.input.sellingCosts': 'Costos de venta (%)',
    'buyRent.input.horizon': 'Horizonte (años)',
    'buyRent.input.propertyTax': 'Impuesto predial (%)',
    'buyRent.input.insurance': 'Seguro de vivienda (anual)',
    'buyRent.input.maintenance': 'Mantenimiento (% del valor)',
    'buyRent.input.hoa': 'Cuotas HOA (mensual)',
    'buyRent.input.monthlyRent': 'Renta mensual',
    'buyRent.input.rentIncrease': 'Incremento anual de renta (%)',
    'buyRent.input.rentersInsurance': 'Seguro del inquilino (mensual)',
    'buyRent.input.securityDeposit': 'Depósito de garantía',
    'buyRent.input.investmentReturn': 'Rendimiento de inversión (%)',
    'buyRent.summary.title': 'Resumen comparativo',
    'buyRent.summary.buyLabel': 'Comprar',
    'buyRent.summary.rentLabel': 'Rentar',
    'buyRent.summary.owningMonthly': 'Costo mensual de propiedad',
    'buyRent.summary.taxes': 'Impuestos',
    'buyRent.summary.ins': 'Seg.',
    'buyRent.summary.maint': 'Mant.',
    'buyRent.summary.rentMonthly': 'Renta mensual inicial',
    'buyRent.summary.avgRent': 'Renta promedio durante el período',
    'buyRent.summary.totalOutlay': 'Desembolso total',
    'buyRent.summary.netCost': 'Costo neto (después de plusvalía)',
    'buyRent.summary.advantage': 'Ventaja',
    'buyRent.summary.note': 'Los valores positivos favorecen comprar.',
    'buyRent.summary.advantage.even': 'Casi igual',
    'buyRent.summary.advantage.buy': 'Ventaja de comprar',
    'buyRent.summary.advantage.rent': 'Ventaja de rentar',
    'buyRent.summary.message.default': 'Ingresa el precio, la hipoteca y el horizonte para comparar.',
    'buyRent.summary.message.even': 'En este horizonte los costos totales de comprar y rentar son muy similares.',
    'buyRent.summary.message.buy': 'Comprar genera más valor neto que rentar bajo estos supuestos.',
    'buyRent.summary.message.rent': 'Rentar deja mayor patrimonio neto que comprar en este escenario.',
    'fixFlip.instructions.title': 'Cómo usar esta calculadora',
    'fixFlip.instructions.intro': 'Ingresa los detalles de la propiedad para calcular el retorno de inversión (ROI) potencial de un proyecto de fix & flip. La calculadora mostrará resultados en tiempo real.',
    'fixFlip.instructions.purchase': '• Precio de compra: el monto que pagarás para adquirir la propiedad',
    'fixFlip.instructions.rehab': '• Costo de rehabilitación: estimación de renovaciones y reparaciones',
    'fixFlip.instructions.arv': '• Valor después de reparaciones (ARV): valor estimado tras las mejoras',
    'fixFlip.instructions.selling': '• Costos de venta: comisiones, costos de cierre, etc. (normalmente 6-8% del ARV)',
    'fixFlip.instructions.holding': '• Costos de tenencia: seguro, servicios, impuestos mientras la poseas',
    'fixFlip.inputs.title': 'Detalles de la propiedad',
    'fixFlip.input.purchase': 'Precio de compra',
    'fixFlip.input.rehab': 'Costo de rehabilitación',
    'fixFlip.input.arv': 'Valor después de reparaciones (ARV)',
    'fixFlip.input.selling': 'Costos de venta (6-8% del ARV)',
    'fixFlip.input.holding': 'Costos de tenencia',
    'fixFlip.results.title': 'Análisis de ROI',
    'fixFlip.results.goodDeal': 'Buena oportunidad',
    'fixFlip.results.review': 'Revisar con cuidado',
    'fixFlip.results.totalInvestment': 'Inversión total',
    'fixFlip.results.netProfit': 'Ganancia neta',
    'fixFlip.results.roiPercentage': 'Porcentaje ROI',
    'fixFlip.results.analysisTitle': 'Análisis',
    'fixFlip.results.analysisLine1': '• ROI objetivo para fix & flip: 20%+ (tuyo: {{roi}}%)',
    'fixFlip.results.analysisLine2': '• Considera condiciones de mercado y riesgos de tiempo',
    'fixFlip.results.empty': 'Ingresa los detalles de la propiedad para calcular el ROI',
    'depreciation.title': 'Calculadora de depreciación',
    'depreciation.description': 'Estima el valor del vehículo conforme envejece, considera el impacto del kilometraje y visualiza la depreciación en el tiempo.',
    'depreciation.section.profile': 'Perfil del vehículo',
    'depreciation.section.assumptions': 'Suposiciones de depreciación',
    'depreciation.input.make': 'Marca',
    'depreciation.input.modelYear': 'Año del modelo',
    'depreciation.input.purchasePrice': 'Precio de compra',
    'depreciation.input.purchaseMileage': 'Kilometraje al comprar',
    'depreciation.input.currentMileage': 'Odómetro actual',
    'depreciation.input.yearsOwned': 'Años desde la compra',
    'depreciation.input.avgAnnualMiles': 'Kilometraje anual promedio',
    'depreciation.input.baselineAnnualMiles': 'Kilometraje anual de referencia',
    'depreciation.input.yearOneDrop': 'Caída el primer año (%)',
    'depreciation.input.ongoingDrop': 'Caída anual posterior (%)',
    'depreciation.input.mileageAdjustment': 'Ajuste por 1k millas',
    'depreciation.input.holdYears': 'Años planeados de uso',
    'depreciation.summary.title': 'Resumen de depreciación',
    'depreciation.summary.caption': 'Basado en {{years}} años de propiedad',
    'depreciation.summary.currentValue': 'Valor actual estimado',
    'depreciation.summary.totalDepreciation': 'Depreciación total',
    'depreciation.summary.avgAnnual': 'Depreciación anual promedio',
    'depreciation.summary.projected': 'Valor proyectado (año {{year}})',
    'depreciation.summary.quality.great': 'Gran retención',
    'depreciation.summary.quality.typical': 'Depreciación típica',
    'depreciation.summary.quality.rapid': 'Depreciación rápida',
    'depreciation.summary.qualityMsg.great': 'Este vehículo mantiene muy bien su valor respecto al precio de compra.',
    'depreciation.summary.qualityMsg.typical': 'La depreciación está en línea con el promedio del mercado.',
    'depreciation.summary.qualityMsg.rapid': 'La depreciación es pronunciada respecto al precio de compra; espera una pérdida de valor más rápida.',
    'depreciation.table.title': 'Cronología de depreciación',
    'depreciation.table.year': 'Año',
    'depreciation.table.value': 'Valor estimado',
    'depreciation.table.depreciation': 'Depreciación anual',
    'depreciation.table.actualMiles': 'Kilometraje real',
    'depreciation.table.expectedMiles': 'Kilometraje esperado',
    'depreciation.table.mileagePenalty': 'Penalización por kilometraje',
    'depreciation.table.milesSuffix': 'km',
    'depreciation.empty': 'Ingresa los detalles del vehículo para calcular la depreciación.',
    'compound.title': 'Calculadora de interés compuesto',
    'compound.description': 'Modela el crecimiento de una inversión con aportaciones recurrentes y tasas ajustables. Revisa la acumulación anual de aportes frente a rendimientos.',
    'compound.section.inputs': 'Entradas',
    'compound.section.guidance': 'Guía',
    'compound.input.initialInvestment': 'Inversión inicial',
    'compound.input.recurringContribution': 'Aportación recurrente',
    'compound.input.annualRate': 'Tasa de interés anual (%)',
    'compound.input.compoundingFrequency': 'Frecuencia de capitalización (por año)',
    'compound.input.contributionFrequency': 'Frecuencia de aportación (por año)',
    'compound.input.yearsToGrow': 'Años de crecimiento',
    'compound.input.rateAdjustment': 'Ajuste de tasa por año (%)',
    'compound.frequency.monthly': 'Mensual',
    'compound.frequency.quarterly': 'Trimestral',
    'compound.frequency.semiAnnual': 'Semestral',
    'compound.frequency.annual': 'Anual',
    'compound.guidance.adjustment': 'Usa el ajuste de tasa para modelar cambios en el rendimiento (por ejemplo, reducir 0.5% cada año).',
    'compound.guidance.frequency': 'La frecuencia de aportación debe coincidir con la frecuencia de inversión (12 = mensual, 4 = trimestral).',
    'compound.guidance.negative': 'Los ajustes negativos simulan rendimientos decrecientes o proyecciones conservadoras.',
    'compound.summary.title': 'Resultados',
    'compound.summary.futureValue': 'Valor futuro',
    'compound.summary.totalContributions': 'Aportaciones totales',
    'compound.summary.growth': 'Crecimiento de la inversión',
    'compound.table.title': 'Desglose anual',
    'compound.table.year': 'Año',
    'compound.table.balance': 'Saldo',
    'compound.table.contributions': 'Aportaciones',
    'compound.table.growth': 'Crecimiento',
    'compound.table.effectiveRate': 'Tasa efectiva',
    'compound.empty': 'Ingresa los detalles de la inversión para calcular el crecimiento compuesto.'
  }
};

const interpolate = (template, values = {}) =>
  template.replace(/{{(.*?)}}/g, (_, key) => (values[key.trim()] ?? ''));

export const translate = (language, key, fallback, values = {}) => {
  const langTable = translations[language] || {};
  const enTable = translations.en || {};
  const template = langTable[key] ?? enTable[key] ?? fallback ?? key;
  return typeof template === 'string' ? interpolate(template, values) : template;
};
